/**
 * Single source of truth for origin, NAP (name / address / phone), and
 * social-card assets. Every canonical, og:url, og:image and schema URL
 * must derive from here - do not hardcode the domain anywhere else.
 */

export const SITE = {
  origin: "https://berkhospitality.com",
  name: "Berk Hospitality Group",

  email: "jett@berkhospitality.com",
  emailHref: "mailto:jett@berkhospitality.com",

  phoneDisplay: "(602) 909-8892",
  phoneE164: "+1-602-909-8892",
  phoneHref: "tel:6029098892",

  locality: "Scottsdale",
  region: "AZ",
  country: "US",
  locationDisplay: "Scottsdale, AZ",
  languages: "EN / ES",

  ogImagePath: "/og-image.jpg",

  social: {
    linkedinCompany: "https://www.linkedin.com/company/berk-hospitality-group",
    linkedinFounder: "https://www.linkedin.com/in/jettberk/",
    instagram: "https://www.instagram.com/berkhospitality/",
    facebook: "https://www.facebook.com/people/Berk-Hospitality-Group/61567084135408/",
    google: "https://www.google.com/search?kgmid=/g/11mlyjsk2f",
  },
} as const;

/** Absolute URL on the canonical (non-www) origin. */
export function abs(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${SITE.origin}${path.startsWith("/") ? path : `/${path}`}`;
}

export const ORG_ID = `${SITE.origin}/#organization`;
export const WEBSITE_ID = `${SITE.origin}/#website`;
export const PERSON_ID = `${SITE.origin}/#jett-berk`;

/** Absolute social card image. */
export const OG_IMAGE = abs(SITE.ogImagePath);

export const POSTAL_ADDRESS = {
  "@type": "PostalAddress",
  addressLocality: SITE.locality,
  addressRegion: SITE.region,
  addressCountry: SITE.country,
} as const;

/** meta entries for an absolute social card - spread into a route's meta array. */
export const ogImageMeta = [
  { property: "og:image", content: OG_IMAGE },
  { name: "twitter:image", content: OG_IMAGE },
];
